import Ship from './ship';

class Battleship extends Ship {
  constructor() {
    super(4);
  }
}

export default Battleship;
